import { Zodios } from "@zodios/core";

import { api } from "@skilitics/interact-online-analytics-query-endpoint-definitions";
import type { UsageAnalyticsQueryApi, UsageAnalyticsQueryCriteria } from "@skilitics/nautilus-core-designer";

import { attachAuthorizationMiddleware } from "../api/infrastructure/index.ts";
import { getRequiredAppSetting } from "../shared/index.ts";

const client = new Zodios(
  getRequiredAppSetting(import.meta.env.REACT_APP_ONLINE_ANALYTICS_QUERY_ENDPOINT, "ONLINE_ANALYTICS_QUERY_ENDPOINT"),
  api,
);
attachAuthorizationMiddleware(client.axios);

const clientApi: UsageAnalyticsQueryApi = {
  getModuleVersions: async (moduleId: string) => {
    const result = await client.getModuleVersionsData({ params: { moduleId } });
    return result.versions;
  },
  getModuleUsage: async (moduleId: string, { startDate, endDate, moduleVersion }: UsageAnalyticsQueryCriteria = {}) =>
    client.getModuleUsage({
      params: { moduleId },
      queries: { moduleVersion, startDate, endDate },
    }),
};

export const useUsageAnalyticsApi = (): UsageAnalyticsQueryApi => clientApi;
